import { _ } from "../../../core/polyglot/polyglot.js";

// Default options for our keyFigures
export default {
	Default: { group: _("Other"), subtitle: "" },
	AccountsReceivables: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Receivables from customers for goods and services"),
	},
	AccountsReceivablesToNetSalesRatio: {
		group: _("Working capital structure"),
		subtitle: _(
			"Percentage of Sales that is tied up in accounts receivables",
		),
	},
	AdjustedEquity: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Equity adjusted with untaxed reserves"),
	},
	AdjustedLiabilities: {
		highchartOptions: { color: "#1c00c4" },
		group: _("Assets, Equity & Debts"),
		subtitle: _("Liabilities adjusted with deferred tax"),
	},
	AdministrativeExpenses: {
		group: _("Income & Costs"),
		subtitle: _(
			"Expenses related to the general operations or overall administration of the business",
		),
	},
	AdministrativeExpensesToNetSalesRatio: {
		group: _("Income/cost structure"),
		subtitle: _("Part of netsales used to cover administrative costs"),
	},
	AllocationsAndProvisions: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Long term obligations"),
	},
	AltCreditPeriodAccountsReceivables: {
		group: _("Equity structure"),
		subtitle: _("Average time for our customers to pay their bills"),
	},
	Appropriations: {
		group: _("Income & Costs"),
		subtitle: _(
			"Tax periodizations that reduce or increase the profit for the period",
		),
	},
	Assets: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("The company's total values summed"),
	},
	// AssetsOpeningBalance - blacklisted
	BankOverdraft: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Used credit amount at the company's disposal"),
	},
	BankOverdraftLimit: {
		group: _("Supplementary"),
		subtitle: _("Credit amount at the company's disposal"),
	},
	CapitalEmployed: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Employed funds that expect returns"),
	},
	CapitalTurnOverRate: {
		group: _("Equity structure"),
		subtitle: _("Net sales relation to total assets"),
	},
	ChangeInAssets: {
		group: _("Growth"),
		subtitle: _("Development of Assets"),
	},
	ChangeInEquityCapital: {
		group: _("Growth"),
		subtitle: _("Growth of Equity"),
	},
	ChangeInNetSales: {
		group: _("Growth"),
		subtitle: _("Net sales growth"),
	},
	ChangeInNumberOfEmployees: {
		group: _("Growth"),
		subtitle: _("Growth of workforce"),
	},
	ChangeInRefinementValue: {
		group: _("Growth"),
		subtitle: _("Refinement growth"),
	},
	ChangeInRefinementValuePerEmployee: {
		group: _("Growth"),
		subtitle: _("Refinement growth per employee"),
	},
	Cost: {},
	CostsBeforeAppropriations: {
		subtitle: _("Total costs before appropriations and taxes"),
	},
	CostsBeforeCostsForEmployees: {
		subtitle: _("Costs for goods and operating expenses"),
	},
	CostsBeforeExtraordinaryIncomeAndExpenses: {
		subtitle: _("Costs before extraordinary expenses"),
	},
	CostsBeforeFinancial: { subtitle: _("Costs before financial items") },
	CostsBeforeImpairmentsAndWriteBack: {
		subtitle: _("Costs before impairments and writeback"),
	},
	CostsBeforeOperatingExpenses: { subtitle: _("Costs for goods") },
	CostsBeforeProfitEntries: { subtitle: _("All cost items summed") },
	CostsBeforeTaxes: { subtitle: _("Total costs before taxes") },
	CostsForEmployees: {
		group: _("Income & Costs"),
		subtitle: _("Cost for labour"),
	},
	CostsForEmployeesPerEmployee: {
		group: _("Income/cost structure"),
		subtitle: _("Average cost per employee"),
	},
	CostsForEmployeesToNetSalesRatio: {
		group: _("Income/cost structure"),
		subtitle: _("Cost per employee"),
	},
	CostsForEmployeesToRefinementValueRatio: {
		group: _("Income/cost structure"),
		subtitle: _("Part of refinement value that compensates the work force"),
	},
	CostsForResearchAndDevelopment: {
		group: _("Supplementary"),
		subtitle: _("Costs for research and development"),
	},
	CostsForResearchAndDevelopmentToNetSalesRatio: {
		group: _("Income/cost structure"),
		subtitle: _("Part of netsales used to cover for R&D costs"),
	},
	CostsOfPremisesAndProperty: {
		group: _("Income & Costs"),
		subtitle: _("Costs such as rent, water and electricity"),
	},
	CostsOfPremisesAndPropertyToNetSalesRatio: {
		group: _("Income/cost structure"),
		subtitle: _("Part of netsales used to cover for cost of premises"),
	},
	Coverage: {
		group: _("Income & Costs"),
		subtitle: _("Profit before separable costs"),
	},
	CoveragePerEmployee: {
		group: _("Profit structure"),
		subtitle: _("Every employees' contribution to cover the costs"),
	},
	CoverageRatio: {
		group: _("Profit structure"),
		subtitle: _("Profit percentage in the next sold item"),
	},
	CreditPeriodAccountsReceivables: {
		group: _("Equity structure"),
		subtitle: _("Average time for our customers to pay their bills"),
	},
	CreditSalesVATIncluded: {
		group: _("Supplementary"),
		subtitle: _("Total amount credited to customers"),
	},
	CurrentAssets: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Liquid assets and assets that can quickly be sold"),
	},
	CurrentInvestmentsAndLiquidFunds: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Current investments and liquid funds"),
	},
	CurrentInvestmentsAndLiquidFundsToNetSalesRatio: {
		group: _("Working capital structure"),
		subtitle: _("Percentage of Sales that is tied up in liquid funds"),
	},
	CurrentLiabilities: {
		group: _("Assets, Equity & Debts"),
		subtitle: _(
			"A company's debts or obligations that are due within one year",
		),
	},
	CurrentLiabilitiesToNetSalesRatio: {
		group: _("Working capital structure"),
		subtitle: _(
			"Percentage of Sales that is tied up in current liabilities",
		),
	},
	CurrentRatioUntappedBankOverdraftIncluded: {
		group: _("Equity structure"),
		subtitle: _("Measure of short term affordability"),
	},
	DebtInterest: {
		group: _("Revenue performance"),
		subtitle: _("Average interest on all debts"),
	},
	DeferredTaxLiability: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Tax liability to be paid later"),
	},
	DeprecationsAccordingToPlan: {
		group: _("Income & Costs"),
		subtitle: _("The periods cost due to the assets deprecation"),
	},
	DeprecationsToNetSalesRatio: {
		group: _("Income/cost structure"),
		subtitle: _("Percentage of Sales that is used to cover deprecations"),
	},
	EquityCapital: { subtitle: _("Debt and equity capital") },
	EquityCapitalAndLiabilities: {
		group: _("Assets, Equity & Debts"),
		subtitle: _(
			"Capital raised from owners or by revenues from the business excluding current year",
		),
	},
	EquityCapitalToNetSalesRatio: {
		group: _("Debt structure"),
		subtitle: _("Percentage of Sales that is tied up in equity"),
	},
	EquityCapitalWithPreliminaryResults: {
		group: _("Assets, Equity & Debts"),
		subtitle: _(
			"Capital raised from owners or by revenues from the business",
		),
	},
	EquityRatio: {
		group: _("Equity structure"),
		subtitle: _("Ability to withstand losses"),
	},
	ExtraordinaryIncomeAndExpenses: {
		group: _("Income & Costs"),
		subtitle: _("Unusual and large items beyond control of management"),
	},
	Financial: {},
	FinancialAssets: {
		group: _("Assets, Equity & Debts"),
		subtitle: _(
			"Machinery and equipment purchased to help revenue-acquiring",
		),
	},
	FinancialAssetsToNetSalesRatio: {
		group: _("Fixed assets structure"),
		subtitle: _("Percentage of Sales that is tied up in financial assets"),
	},
	FinancialCosts: {
		group: _("Income & Costs"),
		subtitle: _(
			"Interest and other costs that incurs in connection with the borrowing of funds",
		),
	},
	FinancialIncome: {
		group: _("Income & Costs"),
		subtitle: _(
			"Interest and other income that incurs due to excess of funds",
		),
	},
	FinancialItemsToNetSalesRatio: {
		group: _("Income/cost structure"),
		subtitle: _(
			"Percentage of Sales that is used to cover financial costs",
		),
	},
	FixedAssets: {
		group: _("Assets, Equity & Debts"),
		subtitle: _(
			"Assets acquired to be used during a longer period of time",
		),
	},
	GoodsForResale: {
		group: _("Income & Costs"),
		subtitle: _("Cost of sold goods during a specific period"),
	},
	GoodsForResaleAndRawMaterial: {
		subtitle: _(
			"Cost of sold goods and raw material during a specific period",
		),
	},
	GrossProfit: {
		group: _("Income & Costs"),
		subtitle: _("Profit after cost of sold goods"),
	},
	GrossProfitMargin: {
		group: _("Profit structure"),
		subtitle: _("Margin on sales"),
	},
	GrossProfitPerEmployee: {
		group: _("Profit structure"),
		subtitle: _("Gross profit per employee"),
	},
	ImpairmentsAndWriteBack: {
		group: _("Income & Costs"),
		subtitle: _("Costs from adjusted valuation of the company's assets"),
	},
	Income: { subtitle: _("Revenue during a certain period") },
	IncomeBeforeFinancial: {
		group: _("Income & Costs"),
		subtitle: _("All income from daily business"),
	},
	IndebtednessRatio: {
		group: _("Leverage indicators"),
		subtitle: _("Financial leverage"),
	},
	IntangibleAssetsToNetSalesRatio: {
		group: _("Fixed assets structure"),
		subtitle: _("Percentage of Sales that is tied up in intangible assets"),
	},
	IntangibleFixedAssets: {
		group: _("Assets, Equity & Debts"),
		subtitle: _(
			"Non-monetary assets that cannot be seen or physically measured",
		),
	},
	InterestBearingLiabilities: {
		group: _("Supplementary"),
		subtitle: _("Debts that the company pays interest on"),
	},
	InterestCoverRatio: {
		group: _("Profit structure"),
		subtitle: _("Ability to pay financial costs"),
	},
	Inventory: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Stock and work in progress"),
	},
	InventoryToNetSalesRatio: {
		group: _("Working capital structure"),
		subtitle: _("Percentage of Sales that is tied up in inventory"),
	},
	InventoryTurnover: {
		group: _("Equity structure"),
		subtitle: _(
			"Number of times inventory is sold per the selected period",
		),
	},
	InventoryYield: {
		group: _("Equity structure"),
		subtitle: _("Expected gross profit on inventory"),
	},
	InvestmentsInPropertyPlantAndEquipmentForTheYear: {
		group: _("Supplementary"),
		subtitle: _("Annual investments in utilities"),
	},
	InvestmentsInPropertyPlantAndEquipmentToNetSalesRatio: {
		group: _("Income & Costs"),
		subtitle: _("Extraordinary costs of a period"),
	},
	LandsAndBuildings: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Real Estate assets"),
	},
	LiquidCurrentAssets: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Current assets excluding inventory"),
	},
	LiquidRatio: {
		group: _("Equity structure"),
		subtitle: _("Measure of short term affordability"),
	},
	LoanRate: {
		group: _("Revenue performance"),
		subtitle: _("Average cost for borrowed money"),
	},
	LoanRatio: {
		group: _("Leverage indicators"),
		subtitle: _("Leverage by borrowing"),
	},
	LongTermLiabilities: {
		subtitle: _("All long-term financial obligations"),
	},
	LongTermLiabilitiesAndAllocationsToNetSalesRatio: {
		group: _("Debt structure"),
		subtitle: _(
			"Percentage of Sales that is tied up in longterm liabilities",
		),
	},
	MachineryAndEquipment: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Equipment purchased to help revenue-acquiring"),
	},
	MachineryAndEquipmentToNetSalesRatio: {
		group: _("Fixed assets structure"),
		subtitle: _(
			"Percentage of Sales that is tied up in machinery and equipment",
		),
	},
	MaterialFixedAssetsToNetSalesRatio: {
		group: _("Fixed assets structure"),
		subtitle: _(
			"Percentage of Sales that is tied up in material fixed assets",
		),
	},
	NetMargin: {
		group: _("Profit structure"),
		subtitle: _("Measure of company profitability"),
	},
	NetOperatingIncomeEbit: {
		group: _("Real Estate"),
		subtitle: _("Real estate industry KPI"),
	},
	NetOperatingIncomeEaitb: {
		group: _("Real Estate"),
		subtitle: _("Real estate industry KPI"),
	},
	NetSales: {
		group: _("Income & Costs"),
		subtitle: _("The period sales of the daily business"),
	},
	NetSalesPerEmployee: {
		group: _("Income/cost structure"),
		subtitle: _("Netsales per employee"),
	},
	NonCurrentLiabilities: {
		group: _("Assets, Equity & Debts"),
		subtitle: _(
			"Financial obligations that are not due within the present accounting year",
		),
	},
	NonCurrentLiabilitiesAndBankOverdraft: {
		group: _("Assets, Equity & Debts"),
		subtitle: _(
			"Financial obligations that are not due within the present accounting year including bank overdraft",
		),
	},
	NonRestrictedEquityCapital: {
		subtitle: _(
			"Non restricted capital raised from owners or by revenues from the business",
		),
	},
	NumberOfEmployees: {
		group: _("Supplementary"),
		subtitle: _("Workforce"),
	},
	OperatingExpenses: {
		group: _("Income & Costs"),
		subtitle: _(
			"Operating expenses is the ongoing cost for running the business",
		),
	},
	OperatingMargin: {
		group: _("Profit structure"),
		subtitle: _("Surplus from the business"),
	},
	OtherCostsForEmployees: {
		group: _("Income & Costs"),
		subtitle: _("Other costs for personnel"),
	},
	OtherCurrentReceivables: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Other current receivables"),
	},
	OtherCurrentReceivablesToNetSalesRatio: {
		group: _("Working capital structure"),
		subtitle: _(
			"Percentage of Sales that is tied up in other current receivables",
		),
	},
	OtherOperatingExpenses: {
		group: _("Income & Costs"),
		subtitle: _("Other expenses"),
	},
	OtherOperatingExpensesToNetSalesRatio: {
		group: _("Income/cost structure"),
		subtitle: _("Part of netsales used to cover for other operating costs"),
	},
	OtherOperatingIncome: {
		group: _("Income & Costs"),
		subtitle: _("Income not derived from the regular business"),
	},
	OtherSellingExpenses: {
		group: _("Real Estate"),
		subtitle: _("Other selling expenses"),
	},
	Profit: {},
	// PreliminaryResult - blacklisted!
	// PreviousPreliminaryResult - blacklisted!
	// Profit = OLD, not used, see ResultAfterAllItems. Profit: { group: _('Profit structure'), subtitle: '' },
	ProfitAfterDeprecations: {
		group: _("Income & Costs"),
		subtitle: _("Profit before financial items and tax"),
	},
	ProfitAfterFinancialItemsPerEmployee: {
		group: _("Profit structure"),
		subtitle: _("Profit after financial items per employee"),
	},
	ProfitBeforeFinancialItemsPerEmployee: {
		group: _("Profit structure"),
		subtitle: _("Profit before financial items per employee"),
	},
	// ProfitEntryAccounts - blacklisted!
	ProfitMargin: {
		group: _("Leverage indicators"),
		subtitle: _("Measure of profitability before financial costs"),
	},
	PropertyCosts: {
		group: _("Real Estate"),
		subtitle: _("Property Costs"),
	},
	PurchaseOfGoodsAndEquipment: {
		group: _("Income & Costs"),
		subtitle: _("Cost of sold goods during a specific period"),
	},
	QuickRatioUntappedBankOverdraftIncluded: {
		group: _("Equity structure"),
		subtitle: _("Payment readiness"),
	},
	RawMaterial: {
		group: _("Income & Costs"),
		subtitle: _("Cost of raw material during a specific period"),
	},
	RefinementRatio: {
		group: _("Profit structure"),
		subtitle: _(
			"Added value that a company's production process creates in relation to Net Sales",
		),
	},
	RefinementValue: {
		group: _("Income & Costs"),
		subtitle: _("The production process' added value"),
	},
	RefinementValuePerEmployee: {
		group: _("Profit structure"),
		subtitle: _(
			"Added value that a company's production process creates per employee",
		),
	},
	RestrictedEquityCapital: {
		subtitle: _("Restricted capital raised from owners"),
	},
	ResultAfterAllItems: {
		group: _("Income & Costs"),
		subtitle: _("Profit after appropriations and taxes"),
	},
	ResultAfterFinancialItems: {
		group: _("Income & Costs"),
		subtitle: _("Profit before tax"),
	},
	ResultBeforeFinancialCosts: {
		group: _("Income & Costs"),
		subtitle: _("Operating profit including financial income"),
	},
	ReturnOnAssets: {
		group: _("Revenue performance"),
		subtitle: _("Yield on total assets"),
	},
	ReturnOnCapitalEmployed: {
		group: _("Revenue performance"),
		subtitle: _("Yield on invested money"),
	},
	ReturnOnEquity: {
		group: _("Revenue performance"),
		subtitle: _("Yield of owners investment in the company"),
	},
	RiskBufferCapital: {
		group: _("Revenue performance"),
		subtitle: _("Return surplus over debt interest"),
	},
	RiskBufferOnCapitalEmployed: {
		group: _("Revenue performance"),
		subtitle: _("Return surplus on loan rate"),
	},
	SalariesSocialBenefitsEtc: {
		group: _("Income & Costs"),
		subtitle: _("Cost for personnel and taxes associated with salaries"),
	},
	SellingExpenses: {
		group: _("Income & Costs"),
		subtitle: _("Expenses incurred and related to making sales"),
	},
	SellingExpensesToNetSalesRatio: {
		group: _("Income/cost structure"),
		subtitle: _("Part of netsales used to cover for selling costs"),
	},
	SeparableCosts: {
		group: _("Supplementary"),
		subtitle: _(
			"Expense that can be directly assigned to a specific activity or transaction",
		),
	},
	Taxes: { group: _("Income & Costs"), subtitle: _("Tax on net profit") },
	// Turnover is just an alias for IncomeBeforeFinancial - blacklisted!
	UntaxedReserves: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Profits not yet taxed"),
	},
	UntaxedReservesToNetSalesRatio: {
		group: _("Debt structure"),
		subtitle: _("Percentage of Sales that is tied up in untaxed reserves"),
	},
	WorkingCapital: {
		group: _("Assets, Equity & Debts"),
		subtitle: _("Operating liquidity available to a business"),
	},
	WorkingCapitalToNetSalesRatio: {
		group: _("Equity structure"),
		subtitle: _("Portion of net sales tied up as Working Capital"),
	},

	//
	// LRFK Beef KPIs
	//
	LRFKCostOfPersonnelForBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationFacilities: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationFacilitiesPerKiloSlaughterWeight: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationFacilitiesPerSucklerCow: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationFacilitiesPerWeanerBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationMachines: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationMachinesPerKiloSlaughterWeight: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationMachinesPerSucklerCow: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationMachinesPerWeanerBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKEmployeesSalariesBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKEuSubsidiesForBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKEuSubsidiesPerKiloSlaughterWeight: {
		group: _("LRFK - Beef"),
		subtitle: _("Subsidies per kilo"),
	},
	LRFKEuSubsidiesPerProductionRound: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKEuSubsidiesPerSucklerCow: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKEuSubsidiesPerWeanerBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Subsidies per animal"),
	},
	LRFKForageCostBeefPerKiloSlaughterWeight: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKForageCostBeefPerWeanerBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKForageCostPerProductionRound: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKForageCostPerSucklerCow: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKIncomeLifestockNonSuckledCalves: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKIncomeLifestockNonSuckledCalvesPerCalves: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKIncomeLifestockNonSuckledCalvesPerKiloLifestockWeight: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKIncomeLifestockNonSuckledCalvesPerSucklerCow: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKLabourCostBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKLabourCostBeefPerKiloSlaughterWeight: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKLabourCostBeefPerProductionRound: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKLabourCostBeefPerWeanerBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKLabourCostPerSucklerCow: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchaseOfFodderForBeefCattle: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchaseOfServicesForBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKSelfProducedForageCostBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKSettlementPriceBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKSettlementPriceBeefPerKiloSlaughterWeightWeanerBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Price per kilo"),
	},
	LRFKSettlementPriceBeefPerProductionRound: {
		group: _("LRFK - Beef"),
		subtitle: _("Received pay per round"),
	},
	LRFKSettlementPriceBeefPerWeanerBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Received pay per weaner beef"),
	},
	LRFKSettlementPriceNonSuckleCalvesPerProductionRound: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKSettlementPriceSlaughterCows: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKSettlementPriceSlaughterCowsPerProductionRound: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKSettlementPriceSlaughterCowsPerSucklerCow: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods income"),
	},
	LRFKTotalForageCostBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Periods cost"),
	},
	LRFKWorkHoursPerProductionRoundBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Time spent"),
	},
	LRFKWorkHoursPerSucklerCows: {
		group: _("LRFK - Beef"),
		subtitle: _("Time spent"),
	},
	LRFKWorkHoursPerWeanerBeef: {
		group: _("LRFK - Beef"),
		subtitle: _("Time spent"),
	},

	//
	// LRFK Common KPIs
	//
	LRFKFinancialCost: {
		group: _("LRFK - Common"),
		subtitle: _("Periods costs"),
	},
	LRFKNetResultFromLandLease: {
		group: _("LRFK - Common"),
		subtitle: _("Periods revenue"),
	},

	//
	// LRFK Crop KPIs
	//
	LRFKContractOperationsForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKContractOperationsPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKCostFromLandLease: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKCropProtection: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods cost"),
	},
	LRFKCropProtectionPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods cost"),
	},
	LRFKDepreciationForCrops: { group: _("LRFK - Crop"), subtitle: _("") },
	LRFKDepreciationPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKDirectCostForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods cost"),
	},
	LRFKDirectCostPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("What is spend per hectare to grow"),
	},
	LRFKDryingCostForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKDryingCostPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKEmployeesSalariesForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("The periods cost for personnel"),
	},
	LRFKEnvironmentalSubsidiesForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKEnvironmentalSubsidiesPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKFertilizerCost: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKFertilizerCostPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _(""),
	},
	LRFKFertilizersAndPesticidesCost: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods cost"),
	},
	LRFKFuelCostForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Cost for running machines"),
	},
	LRFKFuelCostPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKGrainHarvestPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Lands productivity"),
	},
	LRFKGrossProfitForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Profit after covering for cultivational costs"),
	},
	LRFKGrossProfitPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("The acreage efficiency"),
	},
	LRFKHayAndOtherCulturedAcreagePerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Lands productivity"),
	},
	LRFKHectareOfCerealAndOilseed: {
		group: _("LRFK - Crop"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfCultivatedLand: {
		group: _("LRFK - Crop"),
		subtitle: _("Used land"),
	},
	LRFKHectareOtherCultivatedAreaVegetablesAndProteinCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Used land"),
	},
	LRFKHiredPersonnelForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKHiredPersonnelPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Acquired services per hectare"),
	},
	LRFKIncomeForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKIncomeFromLandLease: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKInsuranceAndTractorTaxEtcForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKInsuranceAndTractorTaxEtcPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKInternalIncomeForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKLabourCostForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKLabourCostPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Labour resources needed"),
	},
	LRFKLabourCostsAsPercentageOfProductionValue: {
		group: _("LRFK - Crop"),
		subtitle: _("Part of production that is needed for labour cost"),
	},
	LRFKLandCost: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods revenue"),
	},
	LRFKLandCostsPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Costs for using the land"),
	},
	LRFKMachineCostAsPercentageOfProductionValue: {
		group: _("LRFK - Crop"),
		subtitle: _("Equipment resources needed"),
	},
	LRFKMachineCostForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("The periods need for equipment costs"),
	},
	LRFKMachineCostPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKMachineMaintenanceForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Cost for keeping machines running"),
	},
	LRFKMachineMaintenancePerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKMachineRentAndHiredMachineServicesForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKMachineRentAndHiredMachineServicesPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKNetSalesForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKOtherCostForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKOtherCulturedAcreageInTonsPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Lands productivity"),
	},
	LRFKOtherDirectCostForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods cost"),
	},
	LRFKOtherFertilizerAndLime: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKOtherFertilizerAndLimePerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKOtherIncomeForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKOtherIncomePerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKOtherMachineCostForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKPotatoHarvestPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Lands productivity"),
	},
	LRFKProductionResult: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods revenue"),
	},
	LRFKProductionResultPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods revenue"),
	},
	LRFKProductionValueForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Value that we produce"),
	},
	LRFKProductionValuePer1800Hours: {
		group: _("LRFK - Crop"),
		subtitle: _("Production in 1800 hours"),
	},
	LRFKPurchaseOfServicesAsPercentageOfProductionValue: {
		group: _("LRFK - Crop"),
		subtitle: _("Purchased services needed"),
	},
	LRFKPurchaseOfServicesForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKResultBeforeDepreciation: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods revenue"),
	},
	LRFKResultBeforeDepreciationPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods revenue"),
	},
	LRFKSeedCost: { group: _("LRFK - Crop"), subtitle: _("Periods costs") },
	LRFKSeedsCostPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods costs"),
	},
	LRFKSubsidiesForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKSugarBeetHarvestPerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("Lands productivity"),
	},
	LRFKTotalCropProduction: {
		group: _("LRFK - Crop"),
		subtitle: _("Production"),
	},
	LRFKTotalIncomeForCrops: {
		group: _("LRFK - Crop"),
		subtitle: _("Periods income"),
	},
	LRFKTotalIncomePerHectare: {
		group: _("LRFK - Crop"),
		subtitle: _("The acreage productivity"),
	},

	//
	// LRFK Milk KPIs
	//
	LRFKCompanyOwnerSalaries: { group: _("LRFK - Milk"), subtitle: _("") },
	LRFKConcentrateFodderPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Concentrate feed relation to produced milk"),
	},
	LRFKContributionMarginPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Profit per kilo milk"),
	},
	LRFKCostOfCareForMilkingCows: {
		group: _("LRFK - Milk"),
		subtitle: _(""),
	},
	LRFKEmployeesSalariesForMilk: {
		group: _("LRFK - Milk"),
		subtitle: _(""),
	},
	LRFKForageCostForMilkingCows: {
		group: _("LRFK - Milk"),
		subtitle: _("The periods production"),
	},
	LRFKForagePerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Forage relation to produced milk"),
	},
	LRFKIncomeFromMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods income"),
	},
	LRFKIncomeFromMilkPerCow: {
		group: _("LRFK - Milk"),
		subtitle: _("Each cows contribution"),
	},
	LRFKIncomeFromMilkPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Pay per kilo"),
	},
	LRFKInseminatorAndControlCost: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKInseminatorAndControlCostPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKInterestAndLandLease: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKInterestAndLandLeasePerCow: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKKgOfMilkPerAverageCow: {
		group: _("LRFK - Milk"),
		subtitle: _("The cattles average production per cow"),
	},
	LRFKKgOfMilkPerAverageCowPerDay: {
		group: _("LRFK - Milk"),
		subtitle: _("Production of milk"),
	},
	LRFKKgOfMilkPerCow: {
		group: _("LRFK - Milk"),
		subtitle: _("Kilo per cow"),
	},
	LRFKKgOfMilkPerDay: {
		group: _("LRFK - Milk"),
		subtitle: _("Production of milk"),
	},
	LRFKKgOfMilkPerProducingCow: {
		group: _("LRFK - Milk"),
		subtitle: _("The cattles average production per cow"),
	},
	LRFKKgOfMilkPerProducingCowPerDay: {
		group: _("LRFK - Milk"),
		subtitle: _("Production of milk"),
	},
	LRFKKgOfMilkPerRobot: {
		group: _("LRFK - Milk"),
		subtitle: _("Productivity of robot"),
	},
	LRFKKgOfMilkPerRobotPerDay: {
		group: _("LRFK - Milk"),
		subtitle: _("Productivity of robot per day"),
	},
	LRFKKgOfMilkPerWorkhour: {
		group: _("LRFK - Milk"),
		subtitle: _("How labor intensive is the production of milk"),
	},
	LRFKLabourCostIncludingOwnWorkMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKLabourCostIncludingOwnWorkPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKLiabilitiesForMilkingCows: {
		group: _("LRFK - Milk"),
		subtitle: _("Average dept"),
	},
	LRFKLiabilitiesPerCow: {
		group: _("LRFK - Milk"),
		subtitle: _("Average dept per cow"),
	},
	LRFKMarginForMilkMeatCropsForageSeedFertilizer: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods margin"),
	},
	LRFKMarginForMilkMeatCropsForageSeedFertilizerPerCow: {
		group: _("LRFK - Milk"),
		subtitle: _(""),
	},
	LRFKMilkDeliveredInTons: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods production"),
	},
	LRFKProductionCostForMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKProductionIncomeForMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods income"),
	},
	LRFKProductionResultForMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods result"),
	},
	LRFKProductionResultPerCow: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods result per cow"),
	},
	LRFKPurchaseOfFodderForMilkingCows: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKPurchaseOfFodderPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKPurchaseOfServicesForMilkingCows: {
		group: _("LRFK - Milk"),
		subtitle: _(""),
	},
	LRFKReductionsForMilkingCows: {
		group: _("LRFK - Milk"),
		subtitle: _("Producing and not producing cows"),
	},
	LRFKReliefServices: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKResultBeforeDepreciationsForCows: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods result"),
	},
	LRFKResultBeforeDepreciationsPerCow: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods result per cow"),
	},
	LRFKRevenueAfterForageCostPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Every kilo of milks revenue after forage costs"),
	},
	LRFKSalariesAndReliefServicesPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Costs per kilo"),
	},
	LRFKSelfProducedForMilkingCows: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods cost"),
	},
	LRFKTotalIncomeFromMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods income"),
	},
	LRFKTotalNumberOfCows: { group: _("LRFK - Milk"), subtitle: _("") },
	LRFKTotalWorkHoursForMilk: { group: _("LRFK - Milk"), subtitle: _("") },
	LRFKUsageOfAvailableCowSpots: {
		group: _("LRFK - Milk"),
		subtitle: _("Portion of cowplaces used."),
	},
	LRFKVeterinaryCost: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKVeterinaryCostPerKgOfMilk: {
		group: _("LRFK - Milk"),
		subtitle: _("Periods costs"),
	},
	LRFKWorkHoursPerCow: {
		group: _("LRFK - Milk"),
		subtitle: _("Workhour given to each cow"),
	},

	//
	// LRFK Pig KPIs
	//
	LRFKBeddingCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKBeddingCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKBeddingCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKBreedingCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKCarcassCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKCarcassCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKCarcassCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKCostOfCareForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost of care"),
	},
	LRFKCostOfPersonnelForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Employers cost"),
	},
	LRFKEmployeesSalariesForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost for salaries"),
	},
	LRFKEnergyCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKEnergyCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKEnergyCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKFertilizationCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKFertilizationCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKFertilizationCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKForageCostPerKgForSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("How much does the forage cost per kilo produced meat."),
	},
	LRFKForageCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost for slaughter pig feed"),
	},
	LRFKHousingCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost of housing"),
	},
	LRFKIncomeForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("External sales of slaughter pigs"),
	},
	LRFKInternalForageCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Self produced slaughter pigs food"),
	},
	LRFKKgOfSoldMeatPerPigSpot: {
		group: _("LRFK - Pig"),
		subtitle: _("Production per pig place"),
	},
	LRFKKgOfSoldMeatPerWorkhour: {
		group: _("LRFK - Pig"),
		subtitle: _("Workhour production"),
	},
	LRFKLabourCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Cost of personnel to produce slaughter pigs"),
	},
	LRFKLabourCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Cost for labour per kilo"),
	},
	LRFKLabourCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKMachineAndTransportCostForPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost"),
	},
	LRFKMedicineCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _(""),
	},
	LRFKMedicineCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKMedicineCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKOtherCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _(""),
	},
	LRFKOtherCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKOtherCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKProductionCostIncludingLabourForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("What does it cost to breed one kilo kött"),
	},
	LRFKProductionCostIncludingLabourPerKgOfGrowthForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost"),
	},
	LRFKProductionCostIncludingLabourPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("What does it cost to breed one kilo kött"),
	},
	LRFKProductionCostIncludingLabourPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("What does it cost to breed one slaughter pigs"),
	},
	LRFKPurchaseOfFodderForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Bought slaughter pigs feed"),
	},
	LRFKPurchaseOfFodderPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchaseOfFodderPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchaseOfServicesForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("External personnel"),
	},
	LRFKPurchaseOfSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKRoughageForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods cost"),
	},
	LRFKSettlementPriceByForageCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Received pay by forage ratio"),
	},
	LRFKSettlementPriceForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Received payment"),
	},
	LRFKSettlementPricePerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Received payment per kilo meat"),
	},
	LRFKSettlementPricePerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Received payment per slaughter pig"),
	},
	LRFKSlaughterPigsPerPigSpot: {
		group: _("LRFK - Pig"),
		subtitle: _("Occupancy"),
	},
	LRFKSlaughterPigsPerWorkhour: {
		group: _("LRFK - Pig"),
		subtitle: _("Production per hour"),
	},
	LRFKTotalForageCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Cost for feed"),
	},
	LRFKTotalIncomeForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _("Total sales slaughter pigs"),
	},
	LRFKTotalIncomeMinusForageCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Profit per kilo after forage cost per kilo meat"),
	},
	LRFKVaccineCostForSlaughterPigs: {
		group: _("LRFK - Pig"),
		subtitle: _(""),
	},
	LRFKVaccineCostPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKVaccineCostPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Periods costs"),
	},
	LRFKWorkHoursPerKgOfSoldMeat: {
		group: _("LRFK - Pig"),
		subtitle: _("Time spent per kilo"),
	},
	LRFKWorkHoursPerSlaughterPig: {
		group: _("LRFK - Pig"),
		subtitle: _("Time spent per pig"),
	},

	//
	// LRFK Piglet KPIs
	//
	LRFKBeddingCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods costs"),
	},
	LRFKBeddingCostPerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKBeddingCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKBreedingCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost of breeding"),
	},
	LRFKCarcassCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKCarcassCostPerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKCarcassCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKContributionMargin2ForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Piglets contribution to paying other costs"),
	},
	LRFKContributionMargin2PerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods contribution"),
	},
	LRFKContributionMargin2PerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods contribution"),
	},
	LRFKCostOfCareForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost of care"),
	},
	LRFKCostOfPersonnelForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Employers cost"),
	},
	LRFKEmployeesSalariesForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost for salaries"),
	},
	LRFKEnergyCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods costs"),
	},
	LRFKEnergyCostPerKgOfPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("How much does energy cost per kilo piglet"),
	},
	LRFKEnergyCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("How much does energy cost per piglet"),
	},
	LRFKForageCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Cost for feed"),
	},
	LRFKForageCostPerKgOfPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("How much does the forage cost per kilo produced piglet."),
	},
	LRFKForageCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("How much does the forage cost per produced piglet."),
	},
	LRFKFreightCost: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKHousingCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost of housing"),
	},
	LRFKIncomeForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods sales of piglets"),
	},
	LRFKIncomeFromMachineAndTransportPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods income"),
	},
	LRFKInseminatorCostPerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKInseminatorCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKInseminatorCostPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKInternalForageCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Self produced forage"),
	},
	LRFKKgOfSoldPigletPerSowPlace: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods income"),
	},
	LRFKKgOfSoldPigletsPerWorkhour: {
		group: _("LRFK - Piglet"),
		subtitle: _(
			"Shows how many kilos of sold piglet that is produced per working hour",
		),
	},
	LRFKLabourCostPerKgOfPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Cost for labour per kilo piglet"),
	},
	LRFKLabourCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Cost for labour per piglet"),
	},
	LRFKLegoWorkForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods revenue"),
	},
	LRFKMachineAndTransportCostPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKMedicineCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKMedicineCostPerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKMedicineCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKOtherCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKOtherCostPerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKOtherCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKOverheadCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKProductionCostIncludingLabourForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Cost of producing piglets"),
	},
	LRFKProductionCostIncludingLabourPerKgOfPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("What does it cost to breed one kilo piglet"),
	},
	LRFKProductionCostIncludingLabourPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("What does it cost to breed one piglet"),
	},
	LRFKProtectiveWorkwearPerPigletSold: {
		group: _("LRFK - Piglet"),
		subtitle: _("Costs per sold piglet"),
	},
	LRFKPurchaseOfFodderForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Cost for bought forage"),
	},
	LRFKPurchaseOfFodderPerKgOfPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchaseOfFodderPerPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchaseOfPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost of piglets that was not breed"),
	},
	LRFKPurchaseOfServicesForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("External personnel"),
	},
	LRFKSettlementPriceForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Profit piglets"),
	},
	LRFKSettlementPriceInPercentOfForageCostPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKSettlementPriceMinusTotalForageCost: {
		group: _("LRFK - Piglet"),
		subtitle: _("Shows grossprofit for piglets"),
	},
	LRFKSettlementPricePerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKSettlementPricePerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKSpreadCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKSpreadCostPerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKSpreadCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKTotalCostOfPersonnelForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Salaries etc"),
	},
	LRFKTotalIncomeForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periodens sales of piglets"),
	},
	LRFKTotalMachineAndTransportPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Profit/loss"),
	},
	LRFKVaccineCostForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKVaccineCostPerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKVaccineCostPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKWorkHoursPerSow: {
		group: _("LRFK - Piglet"),
		subtitle: _("Time spend per breeding sow"),
	},
	LRFKWorkWearForPiglets: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKWorkWearPerKgOfPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},
	LRFKWorkWearPerSoldPiglet: {
		group: _("LRFK - Piglet"),
		subtitle: _("Periods cost"),
	},

	//
	// LRFK Poultry KPIs
	//
	LRFKBroilerFodder: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods costs"),
	},
	LRFKCostForCerealPerKg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKCostOfCapitalPerHenSpot: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKCostOfCapitalPerHundredOfHens: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKCostOfCapitalPerKgOfEgg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKCostOfCapitalPerSquareMeter: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKCostOfCapitalPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKCostOfPersonnelForPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKCostOfPoultryCare: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKCostPerKiloOfPrefabricatedFodder: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKEggProductionPerDayPerNumberOfHens: {
		group: _("LRFK - Poultry"),
		subtitle: _("Egg production"),
	},
	LRFKEggProductionPerDayPerNumberOfProducingHens: {
		group: _("LRFK - Poultry"),
		subtitle: _("Egg production"),
	},
	LRFKEggProductionPerHenSpot: {
		group: _("LRFK - Poultry"),
		subtitle: _("Egg production"),
	},
	LRFKEggProductionPerNumberOfHens: {
		group: _("LRFK - Poultry"),
		subtitle: _("Egg production"),
	},
	LRFKEggProductionPerNumberOfProducingHens: {
		group: _("LRFK - Poultry"),
		subtitle: _("Egg production"),
	},
	LRFKEggProductionPerSquareMeter: {
		group: _("LRFK - Poultry"),
		subtitle: _("Egg production"),
	},
	LRFKEmployeesSalariesForPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKForageCostHens: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKForageCostHensPerKgOfEgg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKForagePoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKForageQuotaOfBroilers: {
		group: _("LRFK - Poultry"),
		subtitle: _(""),
	},
	LRFKForageSeedPerKgOfEgg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKIncomeEggsPerSquareMeter: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods income"),
	},
	LRFKIncomeForEggs: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods income"),
	},
	LRFKInsuranceCostPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKInternalForageCostPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKKgBroilerProductionPerSquareMeter: {
		group: _("LRFK - Poultry"),
		subtitle: _(""),
	},
	LRFKKiloForagePerKgOfEgg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Feed per kilo"),
	},
	LRFKLabourCostForPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKManureValuePerBroiler: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods income"),
	},
	LRFKOtherProductionCostPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKPrefabricatedFodderPerKgOfEgg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKProducedBroilersPerSquareMeter: {
		group: _("LRFK - Poultry"),
		subtitle: _(""),
	},
	LRFKProductionCostBroilers: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods costs"),
	},
	LRFKProductionCostPerKgOfBroilers: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods costs"),
	},
	LRFKProductionCostPerKgOfEgg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchaseOfBroilers: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods costs"),
	},
	LRFKPurchaseOfPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchaseOfServicesForPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKPurchasedLayingHensPerNumberOfPullets: {
		group: _("LRFK - Poultry"),
		subtitle: _("Cost per non producing hen"),
	},
	LRFKTotalBroilerForage: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods costs"),
	},
	LRFKTotalForageCostEggProduction: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKTotalForageCostForPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKTotalForagePricePerKg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKTotalIncomeForEggs: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods income"),
	},
	LRFKTotalIncomeOfEggsPerKg: {
		group: _("LRFK - Poultry"),
		subtitle: _("Turnover per kilo"),
	},
	LRFKTotalIncomeOfEggsPerSquareMeter: {
		group: _("LRFK - Poultry"),
		subtitle: _("Productivity"),
	},
	LRFKTotalProductionCostPoultry: {
		group: _("LRFK - Poultry"),
		subtitle: _("Periods cost"),
	},
	LRFKWorkHoursPerThousandsOfBroilers: {
		group: _("LRFK - Poultry"),
		subtitle: _(""),
	},

	//
	// LRFK ZeroAccount KPIs
	//
	LRFKAverageNumberOfCows: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Size of the heard"),
	},
	LRFKBroilerProduction: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKBullProduction: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Weight"),
	},
	LRFKCalfProduction: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Number of calves"),
	},
	LRFKEggProduction: { group: _("LRFK - ZeroAccount"), subtitle: _("") },
	LRFKFailedHens: { group: _("LRFK - ZeroAccount"), subtitle: _("") },
	LRFKGrainHarvestInTons: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKHayAndOtherCultivatedArealInTons: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Production"),
	},
	LRFKHectareOfBerryAndVegetable: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfEOilseed: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfEnergyCrops: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfGrain: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfGrassSeed: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfHay: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfLinseed: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfOtherCultivatedAreas: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfPotato: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfProteinCrops: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfSugarBeet: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Used land"),
	},
	LRFKHectareOfUsedLand: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Amount of land in use by production"),
	},
	LRFKHeiferProduction: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Weight"),
	},
	LRFKInternalIncomeLease: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalLease: { group: _("LRFK - ZeroAccount"), subtitle: _("") },
	LRFKInternalLegoWorkForPiglets: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods cost"),
	},
	LRFKInternalPurchaseOfPigs: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalPurchaseOfServices: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods cost"),
	},
	LRFKInternalSalesOfBeef: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalSalesOfCereals: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalSalesOfForage: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalSalesOfMilk: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKInternalSalesOfOilseeds: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalSalesOfPigs: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods internal sales pigs"),
	},
	LRFKInternalSalesOfPotatoes: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalSalesOfPoultry: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalSalesOfProtein: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods income"),
	},
	LRFKInternalSalesOfServices: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKKgOfCereals: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Consumed feed"),
	},
	LRFKKgOfSoldMilk: { group: _("LRFK - ZeroAccount"), subtitle: _("") },
	LRFKKgOfSoldPiglets: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKKgOfSoldPork: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("How many kilo meat is produced per workhour"),
	},
	LRFKKiloSlaughterWeightWeanerBeef: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Weight"),
	},
	LRFKManureValue: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Periods production"),
	},
	LRFKNumberOfBroilers: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Number of animals"),
	},
	LRFKNumberOfCowSpots: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKNumberOfHenSpots: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Egg production spots"),
	},
	LRFKNumberOfHens: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Egg production workforce"),
	},
	LRFKNumberOfMilkingCows: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Working cows"),
	},
	LRFKNumberOfNonMilkingCows: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKNumberOfPlacesForSlaughterPigs: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKNumberOfRobots: { group: _("LRFK - ZeroAccount"), subtitle: _("") },
	LRFKNumberOfSlaughterPigs: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Number of produced pigs for the period"),
	},
	LRFKNumberOfSows: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("How many mother pigs have been in production"),
	},
	LRFKNumberOfYoungHens: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Not yet egg producers"),
	},
	LRFKOtherCultivatedAreaInTons: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Production"),
	},
	LRFKOwnersSalaries: { group: _("LRFK - ZeroAccount"), subtitle: _("") },
	LRFKOwnersWorkHours: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKPotatoHarvestInTons: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Production"),
	},
	LRFKProductionGrowth: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Weight"),
	},
	LRFKProductionRound: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Number of rounds for the period."),
	},
	LRFKSelfProducedBeddingMaterials: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKSelfProducedCereal: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKSelfProducedConcentrateFodder: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKSelfProducedForage: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKSelfProducedStraw: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKSelfProducedStrawForage: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKSoldPiglets: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("The periods production of small pig"),
	},
	LRFKSowPlace: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Spots for breeding sows"),
	},
	LRFKSquareMeters: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Production facilities"),
	},
	LRFKSteerProduction: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Weight"),
	},
	LRFKSucklerCows: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Number of cows"),
	},
	LRFKSugarBeetsHarvestInTons: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Production"),
	},
	LRFKTotalConcentrateFodder: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _(""),
	},
	LRFKTotalForage: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Weight"),
	},
	LRFKWeanerBeef: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("Number of weaners"),
	},
	LRFKWorkHours: {
		group: _("LRFK - ZeroAccount"),
		subtitle: _("For the period"),
	},

	//
	// Farming KPIs
	//
	NFHectare: {
		group: _("Farming"),
		subtitle: _("Amount of land in use by production"),
	},

	//
	// Generic KPIs
	//
	NFCostForEmployeesPerNumberOfLicences: {
		group: _("Generic"),
		subtitle: _("Cost for personnel per license"),
	},
	NFCostForEmployeesPerNumberOfLogins: {
		group: _("Generic"),
		subtitle: _("Cost for personnel per login"),
	},
	NFCostForEmployeesPerNumberOfUsers: {
		group: _("Generic"),
		subtitle: _("Cost for personnel per user"),
	},
	NFCostForEmployeesPerWorkedOffice: {
		group: _("Generic"),
		subtitle: _("Cost for personnel per office"),
	},
	NFCount: { group: _("Generic"), subtitle: _("Number of things") },
	NFCurrency: { group: _("Generic"), subtitle: _("Currency") },
	NFEuro: { group: _("Generic"), subtitle: _("European currency") },
	NFGBP: { group: _("Generic"), subtitle: _("British Sterling") },
	NFGrossProfitPerNumberOfLicences: {
		group: _("Generic"),
		subtitle: _("Margin after COGS per license"),
	},
	NFGrossProfitPerNumberOfLogins: {
		group: _("Generic"),
		subtitle: _("Margin after COGS per login"),
	},
	NFGrossProfitPerNumberOfUsers: {
		group: _("Generic"),
		subtitle: _("Margin after COGS per user"),
	},
	NFGrossProfitPerWorkedOffice: {
		group: _("Generic"),
		subtitle: _("Margin after COGS per office"),
	},
	NFKilo: { group: _("Generic"), subtitle: _("Weight") },
	NFNetSalesPerNumberOfLicences: {
		group: _("Generic"),
		subtitle: _("Average cost per license"),
	},
	NFNetSalesPerNumberOfLogins: {
		group: _("Generic"),
		subtitle: _("Average cost per login"),
	},
	NFNetSalesPerNumberOfUsers: {
		group: _("Generic"),
		subtitle: _("Average cost per user"),
	},
	NFNetSalesPerWorkedOffice: {
		group: _("Generic"),
		subtitle: _("Average delivery per office"),
	},
	NFNumberOfLicencesSold: {
		group: _("Generic"),
		subtitle: _("Copies of a system sold"),
	},
	NFNumberOfLogins: {
		group: _("Generic"),
		subtitle: _("Times that systems was accessed during the period"),
	},
	NFNumberOfOffices: {
		group: _("Generic"),
		subtitle: _("Places where we operate"),
	},
	NFNumberOfUsers: {
		group: _("Generic"),
		subtitle: _("Active user for period"),
	},
	NFResultAfterFinancialItemsPerNumberOfLicences: {
		group: _("Generic"),
		subtitle: _("Profit/loss before tax per license"),
	},
	NFResultAfterFinancialItemsPerNumberOfLogins: {
		group: _("Generic"),
		subtitle: _("Profit/loss before tax per login"),
	},
	NFResultAfterFinancialItemsPerNumberOfUsers: {
		group: _("Generic"),
		subtitle: _("Profit/loss before tax per user"),
	},
	NFResultAfterFinancialItemsPerWorkedOffice: {
		group: _("Generic"),
		subtitle: _("Profit/loss before tax per office"),
	},
	NFUSD: { group: _("Generic"), subtitle: _("US Currency") },

	//
	// Owner KPIs
	//
	NFCompanyMarketValue: {
		group: _("Owner"),
		subtitle: _("Price of the company derived from share price"),
	},
	NFEarningsPerShare: {
		group: _("Owner"),
		subtitle: _("Periods profit per share"),
	},
	NFEquityCapitalWithPreliminaryResultsPerShare: {
		group: _("Owner"),
		subtitle: _("Value of current assets"),
	},
	NFOwner1NumberOfShares: {
		group: _("Owner"),
		subtitle: _("Shareholding"),
	},
	NFOwner1PartOfEquityCapitalWithPreliminaryResults: {
		group: _("Owner"),
		subtitle: _(
			"What your part of the company is worth if it was closed down",
		),
	},
	NFOwner2NumberOfShares: {
		group: _("Owner"),
		subtitle: _("Shareholding"),
	},
	NFOwner2PartOfEquityCapitalWithPreliminaryResults: {
		group: _("Owner"),
		subtitle: _(
			"What your part of the company is worth if it was closed down",
		),
	},
	NFOwner3NumberOfShares: {
		group: _("Owner"),
		subtitle: _("Shareholding"),
	},
	NFOwner3PartOfEquityCapitalWithPreliminaryResults: {
		group: _("Owner"),
		subtitle: _(
			"What your part of the company is worth if it was closed down",
		),
	},
	NFOwner4NumberOfShares: {
		group: _("Owner"),
		subtitle: _("Shareholding"),
	},
	NFOwner4PartOfEquityCapitalWithPreliminaryResults: {
		group: _("Owner"),
		subtitle: _(
			"What your part of the company is worth if it was closed down",
		),
	},
	NFOwner5NumberOfShares: {
		group: _("Owner"),
		subtitle: _("Shareholding"),
	},
	NFOwner5PartOfEquityCapitalWithPreliminaryResults: {
		group: _("Owner"),
		subtitle: _(
			"What your part of the company is worth if it was closed down",
		),
	},
	NFOwnershipOwner1: {
		group: _("Owner"),
		subtitle: _("Percent of the company that you own"),
	},
	NFOwnershipOwner2: {
		group: _("Owner"),
		subtitle: _("Percent of the company that you own"),
	},
	NFOwnershipOwner3: {
		group: _("Owner"),
		subtitle: _("Percent of the company that you own"),
	},
	NFOwnershipOwner4: {
		group: _("Owner"),
		subtitle: _("Percent of the company that you own"),
	},
	NFOwnershipOwner5: {
		group: _("Owner"),
		subtitle: _("Percent of the company that you own"),
	},
	NFPriceEarningRatio: {
		group: _("Owner"),
		subtitle: _("Company market value in relation to profit"),
	},
	NFSharePriceClosingOfPeriod: {
		group: _("Owner"),
		subtitle: _("Market value of each share"),
	},
	NFTotalNumberOfShares: {
		group: _("Owner"),
		subtitle: _("Outstanding shares"),
	},

	//
	// Personnel KPIs
	//
	NFBillability: {
		group: _("Personnel"),
		subtitle: _("Capacity converted into revenue"),
	},
	NFBilledHours: { group: _("Personnel"), subtitle: _("Time produced") },
	NFCostForEmployeesPerBilledHours: {
		group: _("Personnel"),
		subtitle: _("Cost for personnel per billed hour"),
	},
	NFCostForEmployeesPerWorkHour: {
		group: _("Personnel"),
		subtitle: _("Hourly cost for personnel"),
	},
	NFCostForEmployeesPerWorkedDays: {
		group: _("Personnel"),
		subtitle: _("Cost for personnel per worked days"),
	},
	NFGrossProfitPerBilledHours: {
		group: _("Personnel"),
		subtitle: _("Margin after COGS per billed hour"),
	},
	NFGrossProfitPerWorkHour: {
		group: _("Personnel"),
		subtitle: _("Hourly margin after COGS"),
	},
	NFGrossProfitPerWorkedDays: {
		group: _("Personnel"),
		subtitle: _("Margin after COGS per worked days"),
	},
	NFNetSalesPerBilledHours: {
		group: _("Personnel"),
		subtitle: _("Average hourly rate"),
	},
	NFNetSalesPerWorkHour: {
		group: _("Personnel"),
		subtitle: _("Hourly delivered value"),
	},
	NFNetSalesPerWorkedDays: {
		group: _("Personnel"),
		subtitle: _("Average delivery per worked days"),
	},
	NFResultAfterFinancialItemsPerBilledHours: {
		group: _("Personnel"),
		subtitle: _("Profit/loss before tax per billed hour"),
	},
	NFResultAfterFinancialItemsPerWorkHour: {
		group: _("Personnel"),
		subtitle: _("Hourly profit/loss before tax"),
	},
	NFResultAfterFinancialItemsPerWorkedDays: {
		group: _("Personnel"),
		subtitle: _("Profit/loss before tax per worked days"),
	},
	NFSickDays: {
		group: _("Personnel"),
		subtitle: _("Loss of days in production"),
	},
	NFVacationDays: {
		group: _("Personnel"),
		subtitle: _("Days of from work"),
	},
	NFWorkedDays: {
		group: _("Personnel"),
		subtitle: _("Working days produced for the business"),
	},
	NFWorkedHours: { group: _("Personnel"), subtitle: _("Time produced") },

	//
	// Retail KPIs
	//
	NFCostForEmployeesPerSquareMeters: {
		group: _("Retail"),
		subtitle: _("Hourly cost for personnel"),
	},
	NFExpectedMargin: { group: _("Retail"), subtitle: _("Percentage") },
	NFGrossProfitPerSquareMeters: {
		group: _("Retail"),
		subtitle: _("Hourly margin after COGS"),
	},
	NFNetSalesPerSquareMeters: {
		group: _("Retail"),
		subtitle: _("The value produced per unit of space"),
	},
	NFResultAfterFinancialItemsPerSquareMeters: {
		group: _("Retail"),
		subtitle: _("Hourly profit/loss before tax"),
	},
	NFSquareMeters: { group: _("Retail"), subtitle: _("Facility size") },

	//
	// Sales KPIs
	//
	NFClientsVisits: {
		group: _("Sales"),
		subtitle: _("Number of approaches"),
	},
	NFCostForEmployeesPerNumberOfClients: {
		group: _("Sales"),
		subtitle: _("Cost for personnel per client"),
	},
	NFCostForEmployeesPerNumberOfDaysInPeriod: {
		group: _("Sales"),
		subtitle: _("Cost for personnel per calender day"),
	},
	NFCostForEmployeesPerNumberOfSales: {
		group: _("Sales"),
		subtitle: _("Cost for personnel per sales"),
	},
	NFCostForEmployeesPerStores: {
		group: _("Sales"),
		subtitle: _("Cost for personnel per store"),
	},
	NFGrossProfitMarginServices: {
		group: _("Sales"),
		subtitle: _("Margin after COGS and personnel in Service companies"),
	},
	NFGrossProfitPerNumberOfClients: {
		group: _("Sales"),
		subtitle: _("Margin after COGS per client"),
	},
	NFGrossProfitPerNumberOfDaysInPeriod: {
		group: _("Sales"),
		subtitle: _("Margin after COGS per calender day"),
	},
	NFGrossProfitPerNumberOfSales: {
		group: _("Sales"),
		subtitle: _("Margin after COGS per sales"),
	},
	NFGrossProfitPerStores: {
		group: _("Sales"),
		subtitle: _("Margin after COGS per store"),
	},
	NFGrossProfitServices: {
		group: _("Sales"),
		subtitle: _("Profit after COGS and personnel in Service companies"),
	},
	NFNetSalesPerNumberOfClients: {
		group: _("Sales"),
		subtitle: _("Average client delivery during the period"),
	},
	NFNetSalesPerNumberOfDaysInPeriod: {
		group: _("Sales"),
		subtitle: _("Average sales per calender day"),
	},
	NFNetSalesPerNumberOfSales: {
		group: _("Sales"),
		subtitle: _("Average delivery"),
	},
	NFNetSalesPerStores: {
		group: _("Sales"),
		subtitle: _("Average sales per store"),
	},
	NFNumberOfClients: { group: _("Sales"), subtitle: _("Active clients") },
	NFNumberOfSales: {
		group: _("Sales"),
		subtitle: _("Business activity"),
	},
	NFNumberOfSalesStaff: {
		group: _("Sales"),
		subtitle: _("People active in sales"),
	},
	NFNumberOfStores: { group: _("Sales"), subtitle: _("Points of sales") },
	NFResultAfterFinancialItemsPerNumberOfClients: {
		group: _("Sales"),
		subtitle: _("Profit/loss before tax per client"),
	},
	NFResultAfterFinancialItemsPerNumberOfDaysInPeriod: {
		group: _("Sales"),
		subtitle: _("Profit/loss before tax per calender day"),
	},
	NFResultAfterFinancialItemsPerNumberOfSales: {
		group: _("Sales"),
		subtitle: _("Profit/loss before tax per sales"),
	},
	NFResultAfterFinancialItemsPerStores: {
		group: _("Sales"),
		subtitle: _("Profit/loss before tax per store"),
	},

	//
	// Transport KPIs
	//
	NFCostForEmployeesPerDriven10K: {
		group: _("Transport"),
		subtitle: _("Cost for personnel per 10K"),
	},
	NFCostForEmployeesPerDrivenKilometer: {
		group: _("Transport"),
		subtitle: _("Cost for personnel per kilometer"),
	},
	NFCostForEmployeesPerGasolineConsumed: {
		group: _("Transport"),
		subtitle: _("Cost for personnel per liter gasoline"),
	},
	NFDriven10K: { group: _("Transport"), subtitle: _("Mileage") },
	NFDrivenKilometers: { group: _("Transport"), subtitle: _("Mileage") },
	NFGasolineConsumed: { group: _("Transport"), subtitle: _("In liters") },
	NFGrossProfitPerDriven10K: {
		group: _("Transport"),
		subtitle: _("Margin after COGS per 10K"),
	},
	NFGrossProfitPerDrivenKilometer: {
		group: _("Transport"),
		subtitle: _("Margin after COGS per kilometer"),
	},
	NFGrossProfitPerGasolineConsumed: {
		group: _("Transport"),
		subtitle: _("Margin after COGS per liter gasoline"),
	},
	NFNetSalesPerDriven10K: {
		group: _("Transport"),
		subtitle: _("Delivered value per 10K"),
	},
	NFNetSalesPerDrivenKilometer: {
		group: _("Transport"),
		subtitle: _("Delivered value kilometer"),
	},
	NFNetSalesPerGasolineConsumed: {
		group: _("Transport"),
		subtitle: _("Produced value per liter gasoline"),
	},
	NFResultAfterFinancialItemsPerDriven10K: {
		group: _("Transport"),
		subtitle: _("Profit/loss before tax per driven 10K"),
	},
	NFResultAfterFinancialItemsPerDrivenKilometer: {
		group: _("Transport"),
		subtitle: _("Profit/loss before tax per driven kilometer"),
	},
	NFResultAfterFinancialItemsPerGasolineConsumed: {
		group: _("Transport"),
		subtitle: _("Profit/loss before tax per liter gasoline"),
	},
};
